import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import { NgXCookies } from 'ngx-cookies';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../environments/environment';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class AuthService {


    constructor(private _router: Router, private _http: Http) {}

      // get a new acces token, providing user credentials from login form
      obtainAccessToken(loginData) {
        const params = new URLSearchParams();
        params.append('email', loginData.email);
        params.append('password', loginData.password);
        // params.append('client_id','api');
        const headers = new Headers(
          {'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'});
        const options = new RequestOptions({ headers: headers });
//your account has been archived
        this._http.post(environment.apiEndpoint + environment.loginUrl, params.toString(), options)
          .map(res => res.json())
          .subscribe(
            data => {
              this.saveToken(data)
            },
            err => {
              if (err._body === "your account has been archived") {
                this.throwErrorCount(err)
              } else {
                this.throwError(err)
              }
            }
            );
          };

      processResponse(data){
      }

      throwError(err) {
        alert('Email ou mot de passe erroné');
        this.resetUser();
      }
      //Message d'erreur si le compte est archivé
      throwErrorCount(err) {
        alert('Compte désactivé');
        this.resetUser();
      }


      // POST Login  save token and user informations
      saveToken(data) {
        const expireDate = new Date().getTime() + (1000 * data.expires_in);
        NgXCookies.setCookie('x-access-token', data.token, expireDate);
        // save nom & prenom
        NgXCookies.setCookie('auth-user',data.userDTO.nom + ' '+data.userDTO.prenom);

        // save prenom
        NgXCookies.setCookie('prenom', data.userDTO.prenom);

        //save id user
        NgXCookies.setCookie('idUser', data.userDTO._id);

        // check if the logged user is a candidate
        for(let r of data.userDTO.roles){
          if(r.role == "CANDIDAT"){
            NgXCookies.setCookie('isCandidat', "1");
            this._router.navigate(['/acceuil']);
          }
          if(r.role == "ADMIN"){
            NgXCookies.setCookie('isAdmin', "1");
            this._router.navigate(['/home']);
          }
          if(r.role == "COLLABORATEUR"){
            NgXCookies.setCookie('isCollaborateur', "1");
            this._router.navigate(['/acceuil']);
          }
          if(r.role == "MANAGER"){
            NgXCookies.setCookie('isManager', "1");
            this._router.navigate(['/home']);
          }
        }
        //this._router.navigate(['/home']);
      }

      // check if the user is logged, otherwise redirect to login page
      checkCredentials() {
        if (!NgXCookies.exists('x-access-token')) {
            this._router.navigate(['/login']);
        }
      }

      // Logout
      logout() {
        NgXCookies.deleteCookie('x-access-token');
        NgXCookies.deleteCookie('auth-user');
        NgXCookies.deleteCookie('username');
        NgXCookies.deleteCookie('prenom');
        NgXCookies.deleteCookie('idUser');
        NgXCookies.deleteCookie('isCandidat');
        NgXCookies.deleteCookie('isAdmin');
        NgXCookies.deleteCookie('isManager');
        NgXCookies.deleteCookie('isCollaborateur');
        NgXCookies.deleteCookie('isOldCollaborateur');
        this.resetUser();
        this._router.navigate(['/login']);
      }

      // return the acces token
      getAccesToken() {
        return NgXCookies.getCookie('x-access-token');
      }

      // return true if user is logged in
      isLoggedIn() {
        if (!NgXCookies.exists('x-access-token')) {
           return false;
        }
        return true;
      }

      isAdmin(){
      //);
        return NgXCookies.exists('isAdmin');
      }

      isManager(){
        return NgXCookies.exists('isManager');
      }

      isCollaborateur(){
        return NgXCookies.exists('isCollaborateur');
      }

      isOldCollaborateur(){
        return NgXCookies.exists('isOldCollaborateur');
      }
      // save authenticated user username
      saveUsername(username) {
        NgXCookies.setCookie('username', username, 1000);
      }

      // get le nom & prenom de l'utilisateur connecté
      getAuthenticatedUser() {
        return NgXCookies.getCookie('auth-user');
      }

      getAuthenticatedUsername() {
        return NgXCookies.getCookie('username');
      }

      getAuthenticatedFirstName() {
        return NgXCookies.getCookie('prenom');
      }

      getAuthenticatedIdUser(){
        return NgXCookies.getCookie('idUser');
      }

      resetUser() {
        NgXCookies.deleteCookie('username');
        NgXCookies.deleteCookie('prenom');
      }

      // Reset password
      resetPassword(resetData, token){
        const params = new URLSearchParams();
        params.append('newPassword', resetData.password);
        params.append('verifyPassword', resetData.verifyPassword);
        params.append('token', token);
        // params.append('client_id','api');
        const headers = new Headers(
          {'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'});
        const options = new RequestOptions({ headers: headers });
        this._http.post(environment.apiEndpoint + environment.resetPasswordUrl, params.toString(), options)
          .map(res => res.json())
          .subscribe(
            data => this.redirectLoginPage(),
            err => console.log(err._body));
      };

      redirectLoginPage(){
        this._router.navigate(['/login']);
      }

      redirectProfilPage(){
        this._router.navigate(['/profile']);
      }

      // verifier si le profil est candidat
      isCandidat(){
        return NgXCookies.exists('isCandidat');
      }

      // Reset password
      forgotPassword(_email){
        const params = new URLSearchParams();
        params.append('email', _email);
        const headers = new Headers(
          {'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'});
        const options = new RequestOptions({ headers: headers });
        let response = this._http.post(environment.apiEndpoint + environment.forgotPasswordUrl, params.toString(), options)
        return response
                 .map((res: Response) => res.json())
                 .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

      };


      // envoyer email pour le changement du mot de passe  sur la page de profil de l'utilisateur
      updatePassword(_email){
        const params = new URLSearchParams();
        params.append('email', _email);
        const headers = new Headers(
          {'Content-type': 'application/x-www-form-urlencoded; charset=utf-8', 'x-access-token': this.getAccesToken()});
        const options = new RequestOptions({ headers: headers });
        let response = this._http.post(environment.apiEndpoint + environment.updatePasswordUrl, params.toString(), options)
        return response
                 .map((res: Response) => res.json())
                 .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

      };


      // change son mot de passe
      changePassword(resetData, token){
        const params = new URLSearchParams();
        params.append('newPassword', resetData.password);
        params.append('verifyPassword', resetData.verifyPassword);
        params.append('token', token);
        // params.append('client_id','api');
        const headers = new Headers(
          {'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'});
        const options = new RequestOptions({ headers: headers });
        this._http.post(environment.apiEndpoint + environment.changePasswordUrl, params.toString(), options)
          .map(res => res.json())
          .subscribe(
            data => this.redirectProfilPage(),
            err => this.throwError(err));
      };


}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts